import React, { useMemo } from "react";
import { useStock } from "../../Context/StockContext";
import Grid from "@material-ui/core/Grid";
import "antd/dist/antd.css";
import moment from "moment";
import style from "../../assets/jss/disal-main/Layouts/Stock";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import StockItem from './StockItem';
import StockDetail from './StockDetail';

const useStyles = makeStyles(style);
const today = moment().format("DD/MM/YYYY");
const StockContent = () => {
  const classes = useStyles();
  const miningSites = JSON.parse(localStorage.getItem('miningSites'));
  const {
    miningSite,
    warehouse,
    warehouses,
    stock,
    selected,
    setSelected,
    setMiningSite,
    setWarehouse,
  } = useStock();

  const title = useMemo(() => {
    if(miningSite === 0 && warehouse === 0){
      return "Mostrando stock de residuos para todas las plantas";
    } else if(miningSite !== 0 && warehouse === 0){
      const miningSiteName = miningSites.find((res) => res.id === miningSite).name;
      return "Mostrando stock de residuos para todos los patios de " + miningSiteName;
    } else if(miningSite !== 0 && warehouse !== 0){
      const miningSiteName = miningSites.find((res) => res.id === miningSite).name;
      const warehouseName = warehouses.find((res) => res.id === warehouse).name;
      return "Mostrando stock de residuos para " + warehouseName + " de " + miningSiteName;
    }
    return "";
  }, [miningSite, warehouse, miningSites, warehouses]);

  return (
    <Grid container className={classes.ingresos}>
      <h4>Stock de residuos a la fecha {today}</h4>
      <Grid item sm={12}>
        <Grid container>
          <Grid item sm={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
            >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={miningSite}
                onChange={(e) => {
                  setMiningSite(e.target.value);
                }}
              >
                <MenuItem value={0}>Todos las plantas</MenuItem>
                {miningSites.map((res, key) => {
                  return (
                    <MenuItem key={key} value={res.id}>
                      {res.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item sm={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
            >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={warehouse}
                disabled={miningSite === 0}
                onChange={(e) => {
                  setWarehouse(e.target.value);
                }}
              >
                <MenuItem value={0}>Todos los Patios</MenuItem>
                {warehouses.filter((yard) => yard.mining_site_id === miningSite).map((res, key) => {
                  return (
                    <MenuItem key={key} value={res.id}>
                      {res.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item sm={12} className={classes.mainTable}>
        <h3
          style={{
            color: "#0D0D0D",
            fontFamily: "Roboto",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "20px",
            textAlign: "left",
            marginBottom: "20px",
          }}
        >
          {title}
        </h3>
        <p style={{ color: "#6A6A6A", textDecoration: "underline" }}>Seleccionar tipo de residuo para más detalle</p>
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "10px",
          alignItems: "flex-start",
        }}>
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            justifyContent: "center", 
            alignItems: "flex-start", 
            gap: "10px" 
          }}>
            {stock.map((res, key) => {
              return (
                <StockItem
                  key={`stock-${key}`}
                  stock={res}
                  selected={selected}
                  setSelected={setSelected}
                />
              );
            })}
          </div>
          {selected && <StockDetail stock={selected} />}
        </div>
      </Grid>
    </Grid>
  );
};

export default StockContent;
